import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import {isEmail} from "validator";
import Input from "react-validation/build/input";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";

const required = value => {
  if (!value) {
    return (
        <div className="alert alert-danger" role="alert">
          This field is required!
        </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
        <div className="alert alert-danger" role="alert">
          This is not a valid email.
        </div>
    );
  }
};

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.updateProfile = this.updateProfile.bind(this);
    this.onChangeFirstName = this.onChangeFirstName.bind(this);
    this.onChangeLastName = this.onChangeLastName.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.enableEditProfile = this.enableEditProfile.bind(this);
    this.enableChangePassword = this.enableChangePassword.bind(this);

    this.state = {
      redirect: null,
      userReady: false,
      currentUser: { username: "" },
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      successful: false,
      message: "",
      isProfileFormDisabled: true,
      isPasswordFormDisabled: true,
    };
  }

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();

    if (!currentUser) this.setState({ redirect: "/home" });
    this.setState({ currentUser: currentUser, userReady: true, firstName: currentUser.user.data.firstName, lastName: currentUser.user.data.lastName, email: currentUser.user.username, password: "" });
  }

  onChangeFirstName(e) {
    this.setState({
      firstName: e.target.value
    });
  }

  onChangeLastName(e) {
    this.setState({
      lastName: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    })
  }

  updateProfile(e) {
    e.preventDefault();
    this.setState({
      message: "",
      successful: false
    });
    this.profileForm.validateAll()
    if (this.checkBtn.context._errors.length === 0) {
      AuthService.updateProfile(this.state.firstName, this.state.email, this.state.lastName).then((response) => {
        this.setState({
          message: "Profile Updated Successfully",
          successful: true,
          isProfileFormDisabled: true
        });
      },
          error => {
            const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            this.setState({
              successful: false,
              message: resMessage
            });
          })
    }
  }

  changePassword(e) {
    e.preventDefault();
    this.setState({
      message: "",
      successful: false
    });
    this.passwordForm.validateAll();
    if (this.checkBtnPass.context._errors.length === 0) {
      AuthService.updatePassword(this.state.password, this.state.currentUser.user.username).then((response) => {
            this.setState({
              message: "Password Updated Successfully",
              successful: true,
              password: "",
              isPasswordFormDisabled: true
            });
          },
          error => {
            const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            this.setState({
              successful: false,
              message: resMessage
            });
          })
    }
  }

  enableEditProfile(e) {
    e.preventDefault();
    this.setState({
      isProfileFormDisabled: false
    })
  }

  enableChangePassword(e) {
    e.preventDefault();
    this.setState({
      isPasswordFormDisabled: false
    })
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    const { currentUser } = this.state;

    return (
      <div className="container">
        {(this.state.userReady) ?
            <div>
              <div data-testid="flex" className="d-flex justify-content-center align-items-center mt-2 mb-24px"><p
                  className="fs-0 mb-0 fw-medium text-800">MEMBER DETAILS</p></div>
              <div data-testid="flex" className="d-flex justify-content-between align-items-center mt-2 mb-24px w-100"
                   style={{borderBottom: "2px solid #022e4a"}}><p
                  className="fs-0 mb-0 fw-medium text-800">MY PROFILE</p></div>
              {this.state.message && (
                  <div className="form-group">
                    <div
                        className={
                          this.state.successful
                              ? "alert alert-success"
                              : "alert alert-danger"
                        }
                        role="alert"
                    >
                      {this.state.message}
                    </div>
                  </div>
              )}
              <div className="bg-100 p-2 card-body">
                <div className="mt-3 row">
                  <Form
                      style={{width: "100%"}}
                      onSubmit={this.updateProfile}
                      ref={c => {
                        this.profileForm = c;
                      }}
                  >
                    <div className="row">
                      <div className="mb-3 col-12 col-md-6"><label className="required form-label" htmlFor="firstName">First
                        Name</label><Input required="" placeholder="Amanda" name="firstName"
                                           type="text" className="form-control"
                                           value={this.state.firstName}
                                           validations={[required]}
                                           onChange={this.onChangeFirstName}
                                           disabled={this.state.isProfileFormDisabled}
                      />
                        <div className="invalid-feedback">Please enter valid first name</div>
                      </div>
                      <div className="mb-3 col-12 col-md-6"><label className="required form-label" htmlFor="lastName">Last
                        Name</label><Input required="" placeholder="Victor" name="lastName" pattern="^[a-zA-Z ]{1,50}"
                                           type="text" className="form-control" value={this.state.lastName} validations={[required]}
                                           onChange={this.onChangeLastName}
                                           disabled={this.state.isProfileFormDisabled}
                      />
                        <div className="invalid-feedback">Please enter valid last name</div>
                      </div>
                      <div className="mb-3 col-12 col-md-6"><label className="required form-label"
                                                                   htmlFor="email">Email</label><Input
                                                                                                       required=""
                                                                                                       placeholder="amanda@example.com"
                                                                                                       name="email"
                                                                                                       type="email"
                                                                                                       className="form-control"
                                                                                                       value={this.state.email}
                                                                                                       validations={[required, email]}
                                                                                                       onChange={this.onChangeEmail}
                                                                                                       disabled={this.state.isProfileFormDisabled}
                      />
                      </div>
                      <div className="mb-3 col-12 col-md-6"><label className="required form-label"
                                                                   htmlFor="phone">&nbsp;</label>
                        {this.state.isProfileFormDisabled ? <button type="button" className="w-120px btn btn-primary"><span
                                className="" onClick={this.enableEditProfile}> Edit</span></button> :
                            <button className="w-120px btn btn-primary"><span
                                className=""> Save Changes</span></button>}
                          </div>
                          <CheckButton
                          style={{display: "none"}}
                        ref={c => {
                            this.checkBtn = c;
                          }}
                      />
                    </div>
                  </Form>
                  <Form
                      style={{width: "100%"}}
                      onSubmit={this.changePassword}
                      ref={c => {
                        this.passwordForm = c;
                      }}
                  >
                    <div className="row">
                      <div className="mb-3 col-12 col-md-6"><label className="required form-label"
                                                                   htmlFor="email">Password</label><Input disabled={this.state.isPasswordFormDisabled}
                                                                                                          required=""
                                                                                                          name="password"
                                                                                                          type="password"
                                                                                                          className="form-control"
                                                                                                          value={this.state.password}
                                                                                                          onChange={this.onChangePassword}
                                                                                                          validations={[required]}

                      />
                      </div>
                      <div className="mb-3 col-12 col-md-6"><label className="required form-label"
                                                                   htmlFor="phone">&nbsp;</label>
                        {this.state.isPasswordFormDisabled ? <button type="button" className="w-120px btn btn-primary"><span
                                className="" onClick={this.enableChangePassword}> Change Password</span></button> :
                        <button  className="w-120px btn btn-primary"><span
                            className=""> Save Password</span></button>}
                      </div>
                      <CheckButton
                          style={{ display: "none" }}
                          ref={c => {
                            this.checkBtnPass = c;
                          }}
                      />
                    </div>
                  </Form>
                </div>
              </div>
              <div data-testid="flex" className="d-flex justify-content-between align-items-center mt-2 mb-24px w-100"
                   style={{borderBottom: "2px solid #022e4a"}}><p
                  className="fs-0 mb-0 fw-medium text-800">MY SUBSCRIPTION</p></div>
              <div className="bg-100  p-2 card-body">
                <div className="mt-2 row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">Membership: <span
                      style={{fontWeight: "bold"}}>Savvy Travel Membership - *Reseller Exclusive</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">Purchased From: <span
                      style={{fontWeight: "bold"}}>{currentUser.user.data.clientName}</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName"><span
                      style={{fontWeight: "bold", color: "darkorange"}}>*IMPORTANT: You purchased and brought this membership from {currentUser.user.data.clientName} at an exclusive price. For subscription and billing support, use the VENDOR support details below</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">Standard Monthly Price: <span
                      style={{fontWeight: "bold"}}><s> $89.00</s> per month.</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">{currentUser.user.data.clientName} Monthly
                    Price: <span
                        style={{fontWeight: "bold"}}> ${currentUser.user.subscriber.price ? currentUser.user.subscriber.price : `0.00`} per month.</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <button type="submit" onClick={() => {
                      window.location.href = `mailto:${currentUser.user.data.supportEmail}`
                    }} form="myProfile-id" className="w-120px btn btn-primary"><span
                        className=""> CHANGE MEMBERSHIP</span></button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <a href={`mailto:${currentUser.user.data.supportEmail}`} className="w-120px btn btn-link" style={{ fontSize: "14px", color: '#022e4a' }}> CANCEL MEMBERSHIP</a>
                  </div>
                </div>
              </div>
              <div data-testid="flex" className="d-flex justify-content-between align-items-center mt-2 mb-24px w-100"
                   style={{borderBottom: "2px solid #022e4a"}}><p
                  className="fs-0 mb-0 fw-medium text-800">CUSTOMER AND BILLING SUPPORT</p></div>
              <div className="bg-100  p-2 card-body">
                <div className="mt-2 row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName"><span
                      style={{fontWeight: "bold"}}><i>BILLING AND MEMBERSHIP SUPPORT:</i></span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName"><span
                      style={{fontWeight: "bold", color: "darkorange"}}>*IMPORTANT: You purchased and brought this membership from {currentUser.user.data.clientName} at an exclusive price. For subscription and billing support, use the VENDOR support details below. Savvy Travel cannot help manage your billing or membership details</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">EMAIL:
                    <span
                        style={{fontWeight: "bold"}}> {currentUser.user.data.supportEmail}</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">PHONE:
                    <span
                        style={{fontWeight: "bold"}}> {currentUser.user.data.supportPhone}</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">
                    <span
                      style={{fontWeight: "bold"}}>BOOKING AND RESERVATION SUPPORT:</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <button type="submit" form="myProfile-id" onClick={() => {
                      window.location.href = `https://members.savvywholesaletravel.com/sso?token=${currentUser.access_token}&navigateTo=mytrip/mytrips`;
                    }} className="w-120px btn btn-primary"><span
                        className=""> MANAGE BOOKINGS</span></button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">
                    <span
                      style={{fontWeight: "bold"}}>&nbsp;</span></label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-12"><label className="required form-label"
                                                           htmlFor="firstName">
                    <span
                      style={{fontWeight: "bold"}}>&nbsp;</span></label>
                  </div>
                </div>
              </div>
            </div>
            : null}
      </div>
    );
  }
}
